module.exports = __webpack_public_path__ + "img/card2.a8305fa7.png";